import styled from 'styled-components/macro';
import { Input } from '../../../SubComponents/Inputs';
import useTypeSafeLocalize from '../../../Hooks/use-type-safe-localize';
import { LocalizationCategory, ProductLocalization } from '../../../localizations/types';

const Container = styled.div`
  position: relative;
  max-width: 50%;
`;

interface CustomGiftCardAmountInputProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
}

const CustomGiftCardAmountInput = (props: CustomGiftCardAmountInputProps) => {
  const localize = useTypeSafeLocalize();

  const inputProps = {
    type: 'number',
    placeholder: localize(LocalizationCategory.product, ProductLocalization.customAmount),
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!event.target.value || Number(event.target.value) === 0) {
        return props.onChange(undefined);
      }

      props.onChange(Number(event.target.value));
    },
    value: props.value ?? '',
    min: 1,
  };

  return (
    <Container>
      <Input {...inputProps} />
    </Container>
  );
};

export default CustomGiftCardAmountInput;
